import SaleDetailModal from "../components/SaleDetailModal";
import { Form, Select, InputNumber, Input } from "antd";
import Formatter from "../utils/data_formatter";
import { renderOptions, priceDecimal, PRICE_PARSERS } from "../utils";

const EditColumn = {
  title: "Үйлдэл",
  dataIndex: "edit",
  key: "edit",
  width: 65,
  align: "center",
  isExport: false,
  fixed: "right",
  render: (value, row, index) => (
    <Formatter value={value} format="edit" index={index} row={row} />
  ),
};

const InsYmdColumn = {
  title: "Бүртгэсэн огноо",
  dataIndex: "insymd",
  key: "insymd",
  width: 100,
  align: "center",
  render: (value) => <Formatter value={value} format="date" />,
};

const InsNameColumn = {
  title: "Бүртгэсэн хэрэглэгч",
  dataIndex: "insbyname",
  key: "insbyname",
  width: 100,
};

const StatusColumn = {
  title: "Төлөв",
  dataIndex: "isenable",
  key: "isenable",
  align: "center",
  width: 100,
  exportRender: (value) => <Formatter value={value} format="statusexport" />,
  shouldCellUpdate: (record, prev) => true,
};

const NoColumn = {
  title: "№",
  dataIndex: "no",
  key: "no",
  width: 60,
  align: "center",
  render: (value, row, index) => index + 1,
};

const DeleteColumn = {
  title: "",
  dataIndex: "delete",
  key: "delete",
  width: 65,
  align: "center",
  isExport: false,
  fixed: "right",
  render: (value, row, index) => (
    <Formatter value={value} format="delete" index={index} row={row} />
  ),
  customRender: "delete",
};

export const SaleDetailColumns = [
  NoColumn,
  {
    title: "Барааны нэр",
    dataIndex: "productname",
    key: "productname",
    width: 200,
  },
  {
    title: "Нэгжийн үнэ",
    dataIndex: "price",
    key: "price",
    width: 120,
    align: "right",
    render: (value) => <Formatter value={value} format="price" />,
  },
  {
    title: "Тоо",
    dataIndex: "qty",
    key: "qty",
    width: 60,
    isSum: true,
    align: "right",
  },
  {
    title: "Хямдрал",
    dataIndex: "discount",
    key: "discount",
    width: 100,
    align: "right",
    render: (value) => <Formatter value={value} format="price" />,
  },
  {
    title: "Нийт үнэ",
    dataIndex: "amount",
    key: "amount",
    width: 100,
    align: "right",
    isSum: true,
    render: (value) => <Formatter value={value} format="price" />,
  },
];

export const PriceChangeLogColumn = [
  NoColumn,
  {
    title: "Барааны нэр",
    dataIndex: "productname",
    key: "productname",
    width: 200,
  },
  {
    title: "Өмнөх авах үнэ",
    dataIndex: "oldcost",
    key: "oldcost",
    width: 120,
    align: "right",
    render: (value) => <Formatter value={value} format="price" />,
  },
  {
    title: "Шинэ авах үнэ",
    dataIndex: "cost",
    key: "cost",
    width: 120,
    align: "right",
    render: (value) => <Formatter value={value} format="price" />,
  },
  {
    title: "Өмнөх нэгжийн үнэ",
    dataIndex: "oldprice",
    key: "oldprice",
    width: 120,
    align: "right",
    render: (value) => <Formatter value={value} format="price" />,
  },
  {
    title: "Шинэ нэгжийн үнэ",
    dataIndex: "price",
    key: "price",
    width: 120,
    align: "right",
    render: (value) => <Formatter value={value} format="price" />,
  },
  InsYmdColumn,
];

/* Барааны бүртгэл жагсаалтын хүснэгтийн баганууд */
export const ProductListColumns = [
  NoColumn,
  {
    title: "Код",
    dataIndex: "code",
    width: 120,
    key: "code",
  },
  {
    title: "Барааны нэр",
    dataIndex: "name",
    key: "name",
    width: 150,
  },
  {
    title: "Авах үнэ",
    dataIndex: "cost",
    key: "cost",
    width: 100,
    align: "right",
    render: (value) => <Formatter value={value} format="price" />,
  },
  {
    title: "Нэгж үнэ",
    dataIndex: "price",
    key: "price",
    align: "right",
    width: 130,
    clickable: true,
    render: (value, row) => (
      <Formatter value={value} format="clickable" row={row} />
    ),
    Modal: SaleDetailModal,
    modalColumns: PriceChangeLogColumn,
    modalUrl: "/product/pricelog",
    modalMethod: "GET",
    modalIdKey: "id",
    modalHeader: "Үнэ өөрчлөлтийн түүх",
  },
  {
    title: "Хэмжээ",
    dataIndex: "size",
    key: "size",
    width: 100,
  },
  {
    title: "Ангилал",
    dataIndex: "catname",
    key: "catname",
    width: 150,
  },
  {
    title: "Тайлбар",
    dataIndex: "note",
    key: "note",
    width: 150,
  },
  StatusColumn,
  InsYmdColumn,
  InsNameColumn,
  EditColumn,
  {
    title: "Үйлдэл",
    dataIndex: "printcode",
    key: "printcode",
    width: 100,
    align: "center",
    clickable: true,
    isExport: false,
    fixed: "right",
    render: (value, row, index) => (
      <Formatter value={value} format="printcode" index={index} row={row} />
    ),
  },
];

export const CountListColumns = [
  NoColumn,
  {
    title: "Салбар",
    dataIndex: "storename",
    key: "storename",
    width: 150,
  },
  {
    title: "Тооллогын нэр",
    dataIndex: "name",
    key: "name",
    width: 150,
  },
  {
    title: "Барааны тоо",
    dataIndex: "detailqty",
    key: "detailqty",
    width: 150,
  },
  {
    title: "Тооллогын өөрчлөлт",
    dataIndex: "SeeCnt",
    key: "SeeCnt",
    width: 150,
    render: (value, row) => (
      <Formatter value={value} format="SeeCnt" row={row} />
    ),
  },
  InsYmdColumn,
  InsNameColumn,
];

export const BuyListColumns = [
  NoColumn,
  {
    title: "Татан авсан огноо",
    dataIndex: "logymd",
    key: "logymd",
    width: 150,
    align: "center",
    render: (value) => <Formatter value={value} format="date" />,
  },
  {
    title: "Татан авалтын нэр",
    dataIndex: "name",
    key: "name",
    width: 150,
  },
  {
    title: "Нийлүүлэгч",
    dataIndex: "suppliername",
    key: "suppliername",
    width: 150,
  },
  {
    title: "Төрөл",
    dataIndex: "detailqty",
    key: "detailqty",
    width: 100,
  },
  {
    title: "Бараа харах",
    dataIndex: "SeeBuy",
    key: "SeeBuy",
    align: "center",
    width: 130,
    render: (value, row) => (
      <Formatter value={value} format="SeeBuy" row={row} />
    ),
  },
  {
    title: "Нийт дүн",
    dataIndex: "totalamount",
    key: "totalamount",
    width: 100,
    align: "right",
    isSum: true,
    render: (value) => <Formatter value={value} format="price" />,
  },
  InsYmdColumn,
  InsNameColumn,
  EditColumn,
];

export const OrderListColumns = [
  NoColumn,
  {
    title: "Дэлгүүрийн нэр",
    dataIndex: "storename",
    width: 120,
    key: "storename",
  },
  {
    title: "Захиалгын нэр",
    dataIndex: "name",
    key: "name",
    width: 150,
  },
  {
    title: "Захиалгын төлөв",
    dataIndex: "status",
    key: "status",
    align: "center",
    width: 150,
    render: (value) => <Formatter value={value} format="orderStatus" />,
  },
  {
    title: "Захиалгын огноо",
    dataIndex: "orderymd",
    key: "orderymd",
    width: 150,
    render: (value) => <Formatter value={value} format="date" />,
  },
  {
    title: "Тайлбар",
    dataIndex: "text",
    key: "text",
    width: 150,
  },
  {
    title: "Бараа харах",
    dataIndex: "details",
    key: "details",
    width: 150,
    align: "center",
    render: (value) => <Formatter value={value} format="See" />,
  },
  StatusColumn,
  InsYmdColumn,
  InsNameColumn,
  EditColumn,
];

export const MoveListColumns = [
  NoColumn,
  {
    title: "Шилжүүлсэн дэлгүүр",
    dataIndex: "storename",
    width: 150,
    key: "storename",
  },
  {
    title: "Хүлээн авсан дэлгүүр",
    dataIndex: "fromname",
    width: 150,
    key: "fromname",
  },
  {
    title: "Хөдөлгөөний нэр",
    dataIndex: "name",
    key: "name",
    width: 150,
  },
  {
    title: "Хөдөлгөөний тоо ширхэг",
    dataIndex: "detailqty",
    key: "detailqty",
    width: 150,
  },
  {
    title: "Бараа харах",
    dataIndex: "SeeMove",
    key: "SeeMove",
    width: 150,
    align: "center",
    render: (value, row) => (
      <Formatter value={value} format="SeeMove" row={row} />
    ),
  },
  {
    title: "Хөдөлгөөний огноо",
    dataIndex: "logymd",
    key: "logymd",
    width: 150,
    render: (value) => <Formatter value={value} format="date" />,
  },
  {
    dataIndex: "totalamount",
    title: "Үнийн дүн",
    key: "totalamount",
    width: 150,
    isSum: true,
    render: (value) => <Formatter value={value} format="price" />,
  },
  InsYmdColumn,
  InsNameColumn,
  DeleteColumn,
  // EditColumn,
];

export const SupplierListColumn = [
  NoColumn,
  {
    title: "Нийлүүлэгч нэр",
    dataIndex: "name",
    key: "name",
    width: 150,
  },
  StatusColumn,
  InsYmdColumn,
  InsNameColumn,
  EditColumn,
];

export const StoreFoodColumns = [
  {
    dataIndex: "name",
    title: "Барааны нэр",
    key: "name",
  },
  {
    dataIndex: "cost",
    title: "Өртөг",
    key: "cost",
    render: (value) => <Formatter value={value} format="price" />,
  },
  {
    dataIndex: "price",
    title: "Үнэ",
    key: "price",
    render: (value) => <Formatter value={value} format="price" />,
  },
  {
    dataIndex: "size",
    title: "Хэмжээ",
    key: "size",
  },
];

export const StoreListColumns = [
  NoColumn,
  {
    title: "Салбар",
    dataIndex: "name",
    key: "name",
    width: 150,
  },
  {
    title: "Утас",
    dataIndex: "phone",
    key: "phone",
    width: 150,
  },
  {
    title: "Хаяг",
    dataIndex: "address",
    key: "address",
    width: 150,
  },
  EditColumn,
];

/* Барааны ангилал үүсгэх жагсаалтын хүснэгтийн баганууд */
export const CategoryColumns = [
  NoColumn,
  {
    title: "Ангиллын нэр",
    dataIndex: "name",
    key: "name",
    width: 150,
  },
  StatusColumn,
  InsYmdColumn,
  InsNameColumn,
  EditColumn,
];

export const MoveReportColumns = [
  NoColumn,
  {
    title: "Барааны нэр",
    dataIndex: "name",
    key: "name",
    width: 150,
    align: "center",
  },
  {
    title: "Код",
    dataIndex: "code",
    key: "code",
    align: "right",
    width: 130,
  },
  {
    title: "Ангилал",
    dataIndex: "catname",
    key: "catname",
    align: "right",
    width: 130,
  },
  {
    title: "Хэмжээ",
    dataIndex: "size",
    key: "size",
    align: "right",
    width: 60,
  },
  {
    title: "Зарах үнэ",
    dataIndex: "cost",
    key: "cost",
    width: 130,
    align: "right",
    render: (value, row) => (
      <Formatter value={value} format="price" row={row} />
    ),
  },
  {
    title: "Тоо хэмжээ",
    dataIndex: "qty",
    key: "qty",
    align: "right",
    width: 80,
  },
  {
    title: "Нийт дүн",
    dataIndex: "amount",
    key: "amount",
    align: "right",
    width: 130,
    render: (value, row) => (
      <Formatter value={value} format="price" row={row} />
    ),
  },
  {
    title: "Илгээсэн",
    dataIndex: "storename",
    key: "storename",
    align: "center",
    width: 200,
  },

  {
    title: "Хүлээн авсан",
    dataIndex: "fromname",
    key: "fromname",
    align: "center",
    width: 200,
  },
];

export const BuyReportColumns = [
  NoColumn,
  {
    title: "Барааны нэр",
    dataIndex: "name",
    key: "name",
    width: 150,
    align: "center",
  },
  {
    title: "Код",
    dataIndex: "code",
    key: "code",
    align: "right",
    width: 130,
  },
  {
    title: "Ангилал",
    dataIndex: "catname",
    key: "catname",
    align: "right",
    width: 130,
  },
  {
    title: "Хэмжээ",
    dataIndex: "size",
    key: "size",
    align: "right",
    width: 60,
  },

  {
    title: "Авах үнэ",
    dataIndex: "cost",
    key: "cost",
    align: "right",
    width: 130,
    render: (value, row) => (
      <Formatter value={value} format="price" row={row} />
    ),
  },
  {
    title: "Зарах үнэ",
    dataIndex: "price",
    key: "price",
    align: "right",
    width: 130,
    render: (value, row) => (
      <Formatter value={value} format="price" row={row} />
    ),
  },
  {
    title: "Тоо ширхэг",
    dataIndex: "qty",
    key: "qty",
    align: "right",
    width: 100,
  },
  {
    title: "Дундаж үнэ",
    dataIndex: "avgprice",
    key: "avgprice",
    align: "right",
    width: 130,
    render: (value, row) => (
      <Formatter value={value} format="price" row={row} />
    ),
  },
  {
    title: "Нийт дүн",
    dataIndex: "amount",
    key: "amount",
    align: "right",
    width: 130,
    render: (value, row) => (
      <Formatter value={value} format="price" row={row} />
    ),
  },
];

export const InvReportColumns = [
  NoColumn,
  {
    title: "Салбар",
    dataIndex: "storename",
    key: "storename",
    width: 150,
  },
  {
    title: "Барааны нэр",
    dataIndex: "name",
    key: "name",
    width: 150,
    align: "center",
  },
  {
    title: "Код",
    dataIndex: "code",
    key: "code",
    align: "right",
    width: 130,
  },
  {
    title: "Хэмжээ",
    dataIndex: "size",
    key: "size",
    width: 100,
  },
  {
    title: "Ангилал",
    dataIndex: "catname",
    key: "catname",
    align: "right",
    width: 130,
  },
  {
    title: "Авах үнэ",
    dataIndex: "cost",
    key: "cost",
    align: "right",
    width: 130,
    render: (value, row) => (
      <Formatter value={value} format="price" row={row} />
    ),
  },
  {
    title: "Зарах үнэ",
    dataIndex: "price",
    key: "price",
    align: "right",
    width: 130,
    render: (value, row) => (
      <Formatter value={value} format="price" row={row} />
    ),
  },
  {
    title: "Тоо ширхэг",
    dataIndex: "qty",
    key: "qty",
    align: "right",
    width: 100,
  },
  {
    title: "Нийт үнэ",
    dataIndex: "amount",
    key: "amount",
    align: "right",
    width: 130,
    render: (value, row) => (
      <Formatter value={value} format="price" row={row} />
    ),
  },
  {
    title: "Өөрчлөлт харах",
    dataIndex: "SeeInv",
    key: "SeeInv",
    align: "right",
    width: 130,
    render: (value, row) => (
      <Formatter value={value} format="SeeInv" row={row} />
    ),
  },
  EditColumn,
];

/* Борлуулалтын тайлан жагсаалтын хүснэгтийн баганууд */
export const SaleReportColumns = [
  NoColumn,
  {
    title: "Дэлгүүр",
    dataIndex: "storename",
    key: "storename",
    width: 130,
    align: "center",
  },
  {
    title: "Борлуулалтын огноо",
    dataIndex: "insymd",
    key: "insymd",
    width: 150,
    align: "center",
    render: (value) => <Formatter value={value} format="datetime" />,
  },
  {
    title: "Кассчин",
    dataIndex: "uname",
    key: "uname",
    align: "center",
    width: 80,
  },
  {
    title: "Баримтын дугаар",
    dataIndex: "salenum",
    key: "salenum",
    width: 80,
  },
  {
    title: "Барааны тоо",
    dataIndex: "detailqty",
    key: "detailqty",
    width: 80,
    isSum: true,
    align: "right",
  },
  {
    title: "Баримтын төрөл",
    dataIndex: "peporcom",
    key: "peporcom",
    align: "center",
    width: 100,
  },
  {
    title: "Борлуулалтын төрөл",
    dataIndex: "type",
    key: "type",
    width: 150,
    align: "center",
    render: (value) => <Formatter value={value} format="saletype" />,
  },
  {
    title: "Хямдрал",
    dataIndex: "discount",
    key: "discount",
    align: "right",
    isSum: true,
    width: 130,
    render: (value, row) => (
      <Formatter value={value} format="price" row={row} />
    ),
  },
  {
    title: "НӨАТ",
    dataIndex: "vat",
    key: "vat",
    align: "right",
    isSum: true,
    width: 100,
    render: (value, row) => (
      <Formatter value={value} format="price" row={row} />
    ),
  },
  {
    title: "Бэлнээр",
    dataIndex: "cashamount",
    key: "cashamount",
    align: "right",
    width: 130,
    isSum: true,
    render: (value, row) => (
      <Formatter value={value} format="price" row={row} />
    ),
  },
  {
    title: "Картаар",
    dataIndex: "noncashamount",
    key: "noncashamount",
    align: "right",
    width: 130,
    isSum: true,
    render: (value, row) => (
      <Formatter value={value} format="price" row={row} />
    ),
  },
  {
    title: "Мобайлаар",
    dataIndex: "cashmobile",
    key: "cashmobile",
    align: "right",
    width: 130,
    isSum: true,
    render: (value, row) => (
      <Formatter value={value} format="price" row={row} />
    ),
  },
   {
    title: "Зээл",
    dataIndex: "loan",
    key: "loann",
    align: "right",
    width: 130,
    isSum: true,
    render: (value, row) => (
      <Formatter value={value} format="price" row={row} />
    ),
  },
  {
    title: "Нийт дүн",
    dataIndex: "amount",
    key: "amount",
    align: "right",
    width: 130,
    isSum: true,
    render: (value, row) => (
      <Formatter value={value} format="price" row={row} />
    ),
  },
];

export const SaleDetReportColumns = [
  NoColumn,
  {
    title: "Дэлгүүр",
    dataIndex: "storename",
    key: "storename",
    width: 150,
    align: "center",
  },
  {
    title: "Барааны нэр",
    dataIndex: "productname",
    key: "productname",
    width: 80,
  },
  {
    title: "Барааны тоо",
    dataIndex: "qty",
    key: "qty",
    width: 80,
    isSum: true,
    align: "right",
  },
  {
    title: "Зарах үнэ",
    dataIndex: "price",
    key: "price",
    align: "right",
    width: 130,
    isSum: true,
    render: (value, row) => (
      <Formatter value={value} format="price" row={row} />
    ),
  },
  {
    title: "Нийт дүн",
    dataIndex: "amount",
    key: "amount",
    align: "right",
    width: 130,
    isSum: true,
    render: (value, row) => (
      <Formatter value={value} format="price" row={row} />
    ),
  },
];

/* Материалын тайлан жагсаалтын хүснэгтийн баганууд */
export const MaterialReportColumns = [
  NoColumn,
  {
    title: "Татан авсан огноо",
    dataIndex: "insymd",
    key: "insymd",
    align: "center",
    width: 120,
    render: (value) => <Formatter value={value} format="date" />,
  },
  {
    title: "Код",
    dataIndex: "materialid",
    key: "materialid",
    width: 60,
  },
  {
    title: "Материалын нэр",
    dataIndex: "name",
    key: "name",
  },
  {
    title: "х/нэгж",
    dataIndex: "unitname",
    key: "unitname",
    align: "center",
    width: 80,
  },
  {
    title: "Тоо хэмжээ",
    dataIndex: "qty",
    width: 100,
    key: "qty",
    align: "right",
  },
  {
    title: "Авсан үнэ",
    dataIndex: "price",
    key: "price",
    align: "right",
    width: 100,
    render: (value) => <Formatter value={value} format="price" />,
  },
  {
    title: "Нийт үнэ",
    dataIndex: "amount",
    key: "amount",
    align: "right",
    width: 120,
    render: (value) => <Formatter value={value} format="price" />,
  },
];

/* Материалын үлдэгдлийн тайлан жагсаалтын хүснэгтийн баганууд */
export const MaterialStockReportColumns = [
  NoColumn,
  {
    title: "Материалын код",
    dataIndex: "id",
    key: "id",
    width: 100,
  },
  {
    title: "Материалын нэр",
    dataIndex: "name",
    key: "name",
  },
  {
    title: "х/нэгж",
    dataIndex: "measureunit",
    key: "measureunit",
    align: "center",
    width: 80,
  },
  {
    title: "Нийт татан авалт",
    dataIndex: "buyqty",
    key: "buyqty",
    align: "right",
    width: 100,
    render: (value) => <Formatter value={value} format="price" />,
  },
  {
    title: "Нийт зарцуулалт",
    dataIndex: "salenet",
    key: "salenet",
    align: "right",
    width: 100,
    render: (value) => <Formatter value={value} format="price" />,
  },
  {
    title: "Үлдэгдэл",
    dataIndex: "stock",
    key: "stock",
    align: "right",
    width: 100,
    render: (value) => <Formatter value={value} format="price" />,
  },
  {
    title: "Өртөг",
    dataIndex: "cost",
    key: "cost",
    align: "right",
    width: 100,
    render: (value) => <Formatter value={value} format="price" />,
  },
  {
    title: "Нийт өртөг",
    dataIndex: "totalcost",
    key: "totalcost",
    align: "right",
    width: 120,
    render: (value) => <Formatter value={value} format="price" />,
  },
];

export const MaterialCostDetailColumns = [
  NoColumn,
  {
    title: "Материал",
    dataIndex: "name",
    key: "name",
    width: 300,
  },
  {
    title: "Х/нэгж",
    dataIndex: "measureunit",
    key: "measureunit",
    width: 60,
  },
  {
    title: "Материалын дундаж өртөг",
    dataIndex: "cost",
    key: "cost",
    align: "right",
    isSum: true,
    width: 240,
    render: (value) => <Formatter value={value} format="price" />,
  },
  {
    title: "Нийт орц",
    dataIndex: "net",
    key: "net",
    align: "right",
    isSum: true,
    width: 150,
  },
  {
    title: "Нийт өртөг",
    dataIndex: "total",
    key: "total",
    align: "right",
    render: (value) => <Formatter value={value} format="price" />,
    isSum: true,
    width: 240,
  },
];

export const CostReportDetailColumns = [
  NoColumn,
  {
    title: "Материал",
    dataIndex: "name",
    key: "name",
  },
  {
    title: "Зардлын дүн",
    dataIndex: "amount",
    key: "amount",
    align: "right",
    render: (value) => <Formatter value={value} format="price" />,
    isSum: true,
  },
];

/* Өртөгийн тайлан Барааоор жагсаалтын хүснэгтийн баганууд */
export const CostReportColumns = [
  NoColumn,
  {
    title: "Барааны нэр",
    dataIndex: "productname",
    key: "productname",
    width: 120,
  },
  {
    title: "Ангилал",
    dataIndex: "catname",
    key: "catname",
    width: 120,
  },
  {
    title: "Гарц/порц",
    dataIndex: "portionname",
    key: "portionname",
    width: 100,
  },
  {
    title: "Тоо",
    dataIndex: "qty",
    key: "qty",
    width: 60,
  },
  {
    title: "Материалын зардлын дүн",
    dataIndex: "materialcost",
    key: "materialcost",
    align: "right",
    width: 100,
    render: (value, row) => (
      <Formatter value={value} format="linkPrice" row={row} />
    ),
    clickable: true,
    Modal: SaleDetailModal,
    modalColumns: MaterialCostDetailColumns,
    modalUrl: "/report/detailmaterialcost",
    modalMethod: "POST",
    modalIdKey: "productid",
    modalHeader: "Материалын зардлын задаргаа",
    modalTitles: [
      {
        label: "Барааны нэр",
        valueprop: "productname",
      },
      {
        label: "Барааны картын нэр",
        valueprop: "cardname",
      },
      {
        label: "Шүүсэн огноо",
        valueprop: "sdate,edate",
      },
    ],
  },
  {
    title: "Хуваарилсан зардлын дүн",
    dataIndex: "detailcost",
    key: "detailcost",
    align: "right",
    width: 100,
    render: (value, row) => (
      <Formatter value={value} format="linkPrice" row={row} />
    ),
    clickable: true,
    Modal: SaleDetailModal,
    modalColumns: CostReportDetailColumns,
    modalUrl: "/report/detailcost",
    modalMethod: "POST",
    modalIdKey: "productid",
    modalHeader: "Хуваарилсан зардлын задаргаа",
    modalTitles: [
      {
        label: "Барааны нэр",
        valueprop: "productname",
      },
      {
        label: "Барааны картын нэр",
        valueprop: "cardname",
      },
      {
        label: "Шүүсэн огноо",
        valueprop: "sdate,edate",
      },
    ],
  },
  {
    title: "Нийт зардал",
    dataIndex: "totalcost",
    key: "totalcost",
    align: "right",
    width: 100,
    render: (value) => <Formatter value={value} format="price" />,
  },
  {
    title: "Нэгж Барааны өртөг",
    dataIndex: "cost",
    key: "cost",
    align: "right",
    width: 100,
    render: (value) => <Formatter value={value} format="price" />,
  },
];

export const CostMaterialdetail = [
  NoColumn,
  {
    title: "Бараа",
    dataIndex: "productname",
    key: "productname",
  },
  {
    title: "Х/нэгж",
    dataIndex: "measureunit",
    key: "measureunit",
  },
  {
    title: "Зарагдсан тоо",
    dataIndex: "productqty",
    key: "productqty",
  },
  {
    title: "Дундаж өртөг",
    dataIndex: "cost",
    key: "cost",
    align: "right",
    render: (value) => <Formatter value={value} format="price" />,
  },
  {
    title: "Орц",
    dataIndex: "qty",
    key: "qty",
  },
  {
    title: "Өртөг",
    dataIndex: "totalcost",
    key: "totalcost",
    align: "right",
    render: (value) => <Formatter value={value} format="price" />,
  },
];

/* Өртөгийн тайлан материалаар жагсаалтын хүснэгтийн баганууд */
export const CostMaterialReportColumns = [
  NoColumn,
  {
    title: "Материал",
    dataIndex: "name",
    key: "name",
    width: 200,
  },
  {
    title: "Х/нэгж",
    dataIndex: "measureunit",
    align: "center",
    key: "measureunit",
    width: 60,
  },
  {
    title: "Дундаж өртөг",
    dataIndex: "cost",
    key: "cost",
    align: "right",
    width: 130,
    render: (value) => <Formatter value={value} format="price" />,
  },
  {
    title: "Нийт орц",
    dataIndex: "net",
    key: "net",
    width: 130,
    align: "right",
    render: (value, row) => (
      <Formatter value={value} format="linkPrice" row={row} />
    ),
    clickable: true,
    Modal: SaleDetailModal,
    modalColumns: CostMaterialdetail,
    modalUrl: "/report/detailfood",
    modalMethod: "POST",
    modalIdKey: "id",
    modalHeader: "Орцын задаргаа",
    modalTitles: [
      {
        label: "Материалын нэр",
        valueprop: "name",
      },
      {
        label: "Шүүсэн огноо",
        valueprop: "sdate,edate",
      },
    ],
  },
  {
    title: "Нийт өртөг",
    dataIndex: "total",
    key: "total",
    align: "right",
    width: 150,
    render: (value) => <Formatter value={value} format="price" />,
  },
];

/* Сэт тайлан жагсаалтын хүснэгтийн баганууд */
export const SetReportColumns = [
  NoColumn,
  {
    title: "Сэт код",
    dataIndex: "setid",
    key: "setid",
    width: 200,
  },
  {
    title: "Сэт нэр",
    dataIndex: "name",
    key: "name",
    width: 200,
  },
  {
    title: "Нэр төрөл",
    dataIndex: "detailqty",
    align: "center",
    key: "detailqty",
    width: 60,
  },
  {
    title: "Бүтээгдэхүүний тоо",
    dataIndex: "catqty",
    align: "center",
    key: "catqty",
    width: 60,
  },
  {
    title: "Зарах үнэ",
    dataIndex: "price",
    key: "price",
    align: "right",
    width: 130,
    render: (value) => <Formatter value={value} format="price" />,
  },
  {
    title: "Борлуулсан тоо",
    dataIndex: "qty",
    key: "qty",
    align: "right",
    width: 130,
    render: (value) => <Formatter value={value} format="price" />,
  },
  {
    title: "Нийт дүн",
    dataIndex: "totalamount",
    key: "totalamount",
    align: "right",
    width: 150,
    render: (value) => <Formatter value={value} format="price" />,
  },
];

/* Сэт задаргаа тайлан жагсаалтын хүснэгтийн баганууд */
export const SetDetailReportColumns = [
  NoColumn,
  {
    title: "Борлуулсан огноо",
    dataIndex: "insymd",
    key: "insymd",
    width: 200,
    align: "center",
    render: (value) => <Formatter value={value} format="datetime" />,
  },
  {
    title: "Борлуулалтын төрөл",
    dataIndex: "saletype",
    key: "saletype",
    width: 150,
    align: "center",
    render: (value) => <Formatter value={value} format="saletype" />,
  },
  {
    title: "Код",
    dataIndex: "productid",
    key: "productid",
    width: 100,
  },
  {
    title: "Бүтээгдэхүүний нэр",
    dataIndex: "productname",
    key: "productname",
    width: 200,
  },
  {
    title: "Зарах үнэ",
    dataIndex: "price",
    key: "price",
    align: "right",
    width: 130,
    render: (value) => <Formatter value={value} format="price" />,
  },
  {
    title: "Борлуулсан тоо",
    dataIndex: "qty",
    key: "qty",
    align: "right",
    width: 130,
    render: (value) => <Formatter value={value} format="price" />,
  },
  {
    title: "Хямдрал",
    dataIndex: "discount",
    key: "discount",
    align: "right",
    width: 130,
    render: (value) => <Formatter value={value} format="price" />,
  },
  {
    title: "Борлуулсан дүн",
    dataIndex: "amount",
    key: "amount",
    align: "right",
    width: 130,
    render: (value) => <Formatter value={value} format="price" />,
  },
  {
    title: "НӨАТ",
    dataIndex: "vat",
    key: "vat",
    align: "right",
    isSum: true,
    width: 130,
    render: (value, row) => (
      <Formatter value={value} format="price" row={row} />
    ),
  },
  {
    title: "НХАТ",
    dataIndex: "tax",
    key: "tax",
    align: "right",
    isSum: true,
    width: 130,
    render: (value, row) => (
      <Formatter value={value} format="price" row={row} />
    ),
  },
  // {
  //   title: "Сэт код",
  //   dataIndex: "setid",
  //   key: "setid",
  //   width: 60,
  // },
  {
    title: "Сэт нэр",
    dataIndex: "setname",
    align: "center",
    key: "setname",
    width: 100,
  },
];

/* Зардалын төрөл жагсаалтын хүснэгтийн баганууд */
export const CostTypeColumns = [
  NoColumn,
  {
    title: "Зардлын нэр",
    dataIndex: "name",
    key: "name",
  },
  {
    title: "Зардлын дүн",
    dataIndex: "amount",
    key: "amount",
    align: "right",
    isSum: true,
    render: (value) => <Formatter value={value} format="price" />,
  },
  InsYmdColumn,
  InsNameColumn,
  EditColumn,
];

/* Захиалгийн төрөл жагсаалтын хүснэгтийн баганууд */
export const OrderTypeSettingsColumns = [
  NoColumn,
  {
    title: "Нэр",
    dataIndex: "enumnm",
    key: "enumnm",
  },
  {
    title: "Захиалгын төрөл",
    dataIndex: "typenm",
    key: "typenm",
  },
  InsYmdColumn,
  InsNameColumn,
  EditColumn,
];
/* Хэрэглэгчийн эрх жагсаалтын хүснэгтийн баганууд */
export const UserPermColumns = [
  NoColumn,
  {
    title: "Салбарын нэр",
    dataIndex: "storenm",
    key: "storenm",
  },
  {
    title: "Хэрэглэгчийн овог",
    dataIndex: "firstname",
    key: "firstname",
  },
  {
    title: "Хэрэглэгчийн нэр",
    dataIndex: "lastname",
    key: "firstname",
  },
  {
    title: "Түвшин",
    dataIndex: "type",
    key: "type",
    render: (value) => <Formatter value={value} format="role" />,
  },
  {
    title: "Нэвтрэх нэр",
    dataIndex: "name",
    key: "name",
  },
  {
    title: "Утас",
    dataIndex: "phone",
    key: "phone",
  },
  StatusColumn,
  InsYmdColumn,
  EditColumn,
];

export const PortionList = [
  NoColumn,
  {
    title: "Нэр",
    dataIndex: "name",
    key: "name",
  },
  StatusColumn,
  InsYmdColumn,
  InsNameColumn,
  EditColumn,
];

export const UnitList = [
  NoColumn,
  {
    title: "Нэр",
    dataIndex: "name",
    key: "name",
  },
  StatusColumn,
  InsYmdColumn,
  InsNameColumn,
  EditColumn,
];

export const BranchList = [
  NoColumn,
  {
    title: "Код",
    dataIndex: "branchid",
    key: "branchid",
    width: 70,
  },
  {
    title: "Салбарын нэр",
    dataIndex: "name",
    key: "name",
    width: 150,
  },
  {
    title: "Утас",
    dataIndex: "phoneno",
    key: "phoneno",
    width: 110,
  },
  {
    title: "Салбарын хаяг",
    dataIndex: "address",
    key: "address",
  },
  InsYmdColumn,
  {
    title: "Бүтгэсэн хэрэглэгч",
    dataIndex: "insbyname",
    key: "insbyname",
    width: 110,
  },
];

export const FoodCardDetailColumns = (props, onChange) => [
  NoColumn,
  {
    title: "Орц",
    dataIndex: "materialid",
    key: "materialid",
    width: 150,
    align: "center",
    render: (value, row, i) => (
      <Form.Item
        name={`dfieldmaterialid${i}`}
        initialValue={value}
        rules={[
          { message: `Материал сонгоно уу.`, required: true },
          ({ setFieldsValue, getFieldsValue }) => ({
            validator(_, value) {
              const material =
                props.resmateriallist &&
                props.resmateriallist.find((x) => x.id === value);
              if (material) {
                setFieldsValue({ [`dfieldunitid${i}`]: material.unitid });
              }
              return Promise.resolve();
            },
          }),
        ]}
      >
        <Select
          onChange={(e) => onChange({ value: e, i: i, name: "materialid" })}
          className="w-full"
          showSearch
          defaultActiveFirstOption
          align="left"
          optionFilterProp="children"
        >
          {renderOptions(props.resmateriallist, "name", "id", true)}
        </Select>
      </Form.Item>
    ),
  },
  {
    title: "Хэмжих нэгж",
    dataIndex: "unitid",
    key: "unitid",
    width: 150,
    align: "center",
    render: (value, row, i) => (
      <Form.Item
        name={`dfieldunitid${i}`}
        initialValue={value}
        rules={[{ message: `Хэмжих нэгж сонгоно уу.`, required: true }]}
      >
        <Select
          align="left"
          defaultActiveFirstOption
          onChange={(e) => onChange({ value: e, i: i, name: "unitid" })}
          className="w-full"
        >
          {renderOptions(props.resunitlist, "name", "id")}
        </Select>
      </Form.Item>
    ),
  },
  {
    title: "Бохир жин",
    dataIndex: "gross",
    key: "gross",
    align: "center",
    render: (value, row, i) => (
      <Form.Item
        initialValue={value}
        name={`dfieldgross${i}`}
        rules={[
          { message: `Бохир жин оруулна уу.`, required: true },
          ({ setFieldsValue, getFieldsValue }) => ({
            validator(_, value) {
              let regex = new RegExp(priceDecimal);
              if (!regex.test(value))
                return Promise.reject(new Error("2 оронгийн нарийвчлалтай."));
              return Promise.resolve();
            },
          }),
        ]}
      >
        <InputNumber
          type="number"
          onChange={(e) => onChange({ value: e, i: i, name: "gross" })}
        />
      </Form.Item>
    ),
  },
  {
    title: "Цэвэр жин",
    dataIndex: "net",
    key: "net",
    align: "center",
    render: (value, row, i) => (
      <Form.Item
        initialValue={value}
        name={`dfieldnet${i}`}
        rules={[
          { message: `Цэвэр жин оруулна уу.`, required: true },
          ({ setFieldsValue, getFieldsValue }) => ({
            validator(_, value) {
              let regex = new RegExp(priceDecimal);
              if (!regex.test(value))
                return Promise.reject(new Error("2 оронгийн нарийвчлалтай."));
              return Promise.resolve();
            },
          }),
        ]}
      >
        <InputNumber
          type="number"
          onChange={(e) => onChange({ value: e, i: i, name: "net" })}
        />
      </Form.Item>
    ),
  },
];

export const SetFoodDetailColumns = (props, onChange) => [
  NoColumn,
  {
    title: "Зураг",
    dataIndex: "imgpos",
    key: "imgpos",
    align: "center",
    render: (value) => <Formatter value={value} format="img" />,
  },
  {
    title: "Бүтээгдэхүүн",
    dataIndex: "productid",
    key: "productid",
    width: 150,
    align: "center",
    shouldCellUpdate: () => true,
    render: (value, row, i) => {
      return (
        <Form.Item
          name={`dfieldproductid${i}`}
          initialValue={value}
          rules={[{ message: `Бараа сонгоно уу.`, required: true }]}
        >
          <Select
            onChange={(e) => onChange({ value: e, i: i, name: "productid" })}
            className="w-full"
            showSearch
            defaultActiveFirstOption
            align="left"
            disabled
            loading={props.isfoodlist}
            optionFilterProp="children"
          >
            {renderOptions(props.resfoodlist, "name", "id")}
          </Select>
        </Form.Item>
      );
    },
  },
  {
    title: "Хэмжих нэгж",
    dataIndex: "unitname",
    key: "unitname",
    width: 60,
    align: "center",
    render: (value, row, i) => (
      <Form.Item name={`dfieldunitname${i}`} initialValue={value}>
        <Input disabled />
      </Form.Item>
    ),
  },
  {
    title: "Тоо хэмжээ",
    dataIndex: "qty",
    key: "qty",
    align: "center",
    width: 80,
    render: (value, row, i) => (
      <Form.Item
        initialValue={value}
        name={`dfieldqty${i}`}
        rules={[
          { message: `Тоо хэмжээ.`, required: true },
          ({ setFieldsValue, getFieldsValue }) => ({
            validator(_, value) {
              let regex = new RegExp(priceDecimal);
              if (!regex.test(value))
                return Promise.reject(new Error("2 оронгийн нарийвчлалтай."));
              return Promise.resolve();
            },
          }),
        ]}
      >
        <InputNumber
          className="sm:w-20 xl:w-full"
          min={1}
          max={99999.99}
          {...PRICE_PARSERS}
          onChange={(e) => onChange({ value: e, i: i, name: "qty" })}
        />
      </Form.Item>
    ),
  },
  {
    title: "Нэгжийн үнэ",
    dataIndex: "price",
    key: "price",
    align: "center",
    width: 120,
    render: (value, row, i) => {
      return (
        <Form.Item initialValue={value} name={`dfieldprice${i}`}>
          <InputNumber
            className="sm:w-28 xl:w-full"
            disabled
            {...PRICE_PARSERS}
          />
        </Form.Item>
      );
    },
  },
  {
    title: "Нийт үнэ",
    dataIndex: "amount",
    key: "amount",
    align: "center",
    width: 150,
    render: (value, row, i) => {
      return (
        <Form.Item initialValue={value} name={`dfieldamount${i}`}>
          <InputNumber
            className="sm:w-28 xl:w-full"
            disabled
            {...PRICE_PARSERS}
          />
        </Form.Item>
      );
    },
  },
  {
    title: "Хямдрал",
    dataIndex: "discount",
    key: "discount",
    align: "center",
    width: 120,
    render: (value, row, i) => {
      return (
        <Form.Item initialValue={value} name={`dfielddiscount${i}`}>
          <InputNumber
            className="sm:w-28 xl:w-full"
            disabled
            {...PRICE_PARSERS}
          />
        </Form.Item>
      );
    },
  },
  {
    title: "Хямдарсан дүн",
    dataIndex: "discoAmt",
    key: "discoAmt",
    align: "center",
    width: 120,
    render: (value, row, i) => {
      return (
        <Form.Item initialValue={value} name={`dfielddiscoAmt${i}`}>
          <InputNumber
            className="sm:w-28 xl:w-full"
            disabled
            {...PRICE_PARSERS}
          />
        </Form.Item>
      );
    },
  },
];

export const MaterialBuyingDetailColumns = (props, onChange) => [
  NoColumn,
  {
    title: "Материал",
    dataIndex: "materialid",
    key: "materialid",
    width: 200,
    align: "center",
    // ellipsis: true,
    render: (value, row, i) => (
      <Form.Item
        name={`dfieldmaterialid${i}`}
        initialValue={value}
        rules={[
          { message: `Материал сонгоно уу.`, required: true },
          /*  ({ setFieldsValue, getFieldsValue }) => ({
            validator(_, value) {
              const material = props.resmateriallist && props.resmateriallist.find((x) => x.id === value);
              if (material) {
                setFieldsValue({ [`dfieldunitid${i}`]: material.unitid });
              }
              return Promise.resolve();
            },
          }), */
        ]}
      >
        <Select
          className="sm:w-48 xl:w-full"
          showSearch
          defaultActiveFirstOption
          align="left"
          optionFilterProp="children"
          onChange={(e) => onChange({ value: e, i: i, name: "materialid" })}
        >
          {renderOptions(props.resmateriallist, "name", "id", true)}
        </Select>
      </Form.Item>
    ),
  },
  {
    title: "Хэмжих нэгж",
    dataIndex: "unitid",
    key: "unitid",
    width: 80,
    align: "center",
    render: (value, row, i) => (
      <Form.Item
        name={`dfieldunitid${i}`}
        align="left"
        initialValue={value}
        rules={[{ message: `Хэмжих нэгж сонгоно уу.`, required: true }]}
      >
        <Select
          onChange={(e) => onChange({ value: e, i: i, name: "unitid" })}
          className="sm:w-14 xl:w-full"
        >
          {renderOptions(props.resunitlist, "name", "id")}
        </Select>
      </Form.Item>
    ),
  },
  {
    title: "Тоо хэмжээ",
    dataIndex: "qty",
    key: "qty",
    align: "center",
    width: 130,
    render: (value, row, i) => (
      <Form.Item
        initialValue={value}
        name={`dfieldqty${i}`}
        rules={[
          { message: `Тоо хэмжээ.`, required: true },
          ({ setFieldsValue, getFieldsValue }) => ({
            validator(_, value) {
              let regex = new RegExp(priceDecimal);
              if (!regex.test(value))
                return Promise.reject(new Error("2 оронгийн нарийвчлалтай."));
              return Promise.resolve();
            },
          }),
        ]}
      >
        <InputNumber
          className="sm:w-20 xl:w-full"
          min={0}
          max={99999.99}
          {...PRICE_PARSERS}
          onChange={(e) => onChange({ value: e, i: i, name: "qty" })}
        />
      </Form.Item>
    ),
  },
  {
    title: "Авах үнэ",
    dataIndex: "price",
    key: "price",
    align: "center",
    width: 180,
    render: (value, row, i) => (
      <Form.Item
        initialValue={value}
        name={`dfieldprice${i}`}
        rules={[{ message: `Авах үнэ оруулна уу.`, required: true }]}
      >
        <InputNumber
          className="sm:w-24 xl:w-full"
          min={0}
          max={9999999999.99}
          {...PRICE_PARSERS}
          onChange={(e) => onChange({ value: e, i: i, name: "price" })}
        />
      </Form.Item>
    ),
  },
  {
    title: "Нийт үнэ",
    dataIndex: "amount",
    key: "amount",
    align: "center",
    width: 200,
    render: (value, row, i) => {
      return (
        <Form.Item initialValue={value} name={`dfieldamount${i}`}>
          <InputNumber
            className="sm:w-28 xl:w-full"
            disabled
            {...PRICE_PARSERS}
          />
        </Form.Item>
      );
    },
  },
];

export const DiscountTableColumn = [
  {
    title: "Код",
    dataIndex: "barcode",
    key: "barcode",
    width: 80,
    align: "center",
  },
  {
    title: "Барааны нэр",
    dataIndex: "productname",
    key: "productname",
  },
  {
    title: "Үнэ",
    dataIndex: "price",
    key: "price",
    render: (value) => <Formatter value={value} format="price" />,
  },
  {
    title: "Хямдрал",
    dataIndex: "unitdiscount",
    key: "unitdiscount",
    render: (value, row, i) => (
      <Form.Item noStyle initialValue={value} name={`unitdiscount`}>
        <InputNumber disabled {...PRICE_PARSERS} />
      </Form.Item>
    ),
  },
  {
    title: "Хямдарсан үнэ",
    dataIndex: "amount",
    key: "amount",
    render: (value, row, i) => (
      <Form.Item noStyle initialValue={value} name={`amount`}>
        <InputNumber disabled {...PRICE_PARSERS} />
      </Form.Item>
    ),
  },
];

export const PaymentCloseColumn = (onChange) => [
  {
    title: "Дэвсгэрт",
    dataIndex: "amount",
    key: "amount",
    width: 120,
    render: (value) => <Formatter value={value} format="price" />,
  },
  {
    title: "Тоо",
    dataIndex: "qty",
    key: "qty",
    isSum: true,
    width: 120,
    align: "center",
    render: (value, row, i) => (
      <Form.Item noStyle initialValue={0} name={`qty${i}`}>
        <InputNumber
          precision={0}
          min={0}
          maxLength={6}
          className="w-full"
          type="number"
          {...PRICE_PARSERS}
          onChange={(e) => onChange({ value: e, i: i })}
        />
      </Form.Item>
    ),
  },
  {
    title: "Нийт",
    dataIndex: "totalamt",
    key: "totalamt",
    isSum: true,
    width: 200,
    align: "center",
    render: (value, row, i) => (
      <Form.Item noStyle initialValue={0} name={`totalamt${i}`}>
        <InputNumber className="w-full" disabled {...PRICE_PARSERS} />
      </Form.Item>
    ),
  },
];

export const SaleListColumns = [
  NoColumn,
  {
    title: "Борлуулалтын огноо",
    dataIndex: "insymd",
    key: "insymd",
    width: 150,
    align: "center",
    render: (value) => <Formatter value={value} format="datetime" />,
  },
  {
    title: "Кассчин",
    dataIndex: "uname",
    key: "uname",
    align: "center",
    width: 80,
  },
  {
    title: "Баримтын дугаар",
    dataIndex: "salenum",
    key: "salenum",
    width: 80,
  },
  {
    title: "Барааны тоо",
    dataIndex: "detailqty",
    key: "detailqty",
    width: 80,
    isSum: true,
    align: "right",
  },
  {
    title: "Баримтын төрөл",
    dataIndex: "peporcom",
    key: "peporcom",
    align: "center",
    width: 100,
  },
  {
    title: "Борлуулалтын төрөл",
    dataIndex: "type",
    key: "type",
    width: 150,
    align: "center",
    render: (value) => <Formatter value={value} format="saletype" />,
  },
  {
    title: "Хямдрал",
    dataIndex: "discount",
    key: "discount",
    align: "right",
    isSum: true,
    width: 130,
    render: (value, row) => (
      <Formatter value={value} format="price" row={row} />
    ),
  },
  {
    title: "НӨАТ",
    dataIndex: "vat",
    key: "vat",
    align: "right",
    isSum: true,
    width: 130,
    render: (value, row) => (
      <Formatter value={value} format="price" row={row} />
    ),
  },
  {
    title: "Нийт дүн",
    dataIndex: "amount",
    key: "amount",
    align: "right",
    width: 130,
    clickable: true,
    isSum: true,
    fixed: "right",
    render: (value, row) => (
      <Formatter value={value} format="priceSaleType" row={row} />
    ),
    Modal: SaleDetailModal,
    isReturn: true,
    modalColumns: SaleDetailColumns,
    modalUrl: "/sale/saledetail",
    modalMethod: "GET",
    modalIdKey: "id",
  },
];

export const BuyingDetailColumns = (props, onChange) => [
  NoColumn,
  {
    title: "Бараа",
    dataIndex: "productid",
    key: "productid",
    width: 200,
    align: "center",
    render: (value, row, i) => (
      <Form.Item
        name={`dfieldproductid${i}`}
        initialValue={value}
        rules={[{ message: `Бараа сонгоно уу.`, required: true }]}
      >
        <Select
          className="sm:w-48 xl:w-full"
          showSearch
          defaultActiveFirstOption
          align="left"
          optionFilterProp="children"
          onChange={(e) => onChange({ value: e, i: i, name: "productid" })}
        >
          {renderOptions(props.resproductlist, "name", "id", true)}
        </Select>
      </Form.Item>
    ),
  },
  {
    title: "Тоо хэмжээ",
    dataIndex: "qty",
    key: "qty",
    align: "center",
    width: 130,
    render: (value, row, i) => (
      <Form.Item
        initialValue={value}
        name={`dfieldqty${i}`}
        rules={[
          { message: `Тоо хэмжээ.`, required: true },
          () => ({
            validator(_, value) {
              let regex = new RegExp(priceDecimal);
              if (!regex.test(value))
                return Promise.reject(new Error("2 оронгийн нарийвчлалтай."));
              return Promise.resolve();
            },
          }),
        ]}
      >
        <InputNumber
          className="sm:w-20 xl:w-full"
          min={0}
          max={99999.99}
          {...PRICE_PARSERS}
          onChange={(e) => onChange({ value: e, i: i, name: "qty" })}
        />
      </Form.Item>
    ),
  },
  {
    title: "Авах үнэ",
    dataIndex: "price",
    key: "price",
    align: "center",
    width: 180,
    render: (value, row, i) => (
      <Form.Item
        initialValue={value}
        name={`dfieldprice${i}`}
        rules={[{ message: `Авах үнэ оруулна уу.`, required: true }]}
      >
        <InputNumber
          className="sm:w-24 xl:w-full"
          min={0}
          max={9999999999.99}
          {...PRICE_PARSERS}
          onChange={(e) => onChange({ value: e, i: i, name: "price" })}
        />
      </Form.Item>
    ),
  },
  {
    title: "Нийт үнэ",
    dataIndex: "amount",
    key: "amount",
    align: "center",
    width: 200,
    render: (value, row, i) => {
      return (
        <Form.Item initialValue={value} name={`dfieldamount${i}`}>
          <InputNumber
            className="sm:w-28 xl:w-full"
            disabled
            {...PRICE_PARSERS}
          />
        </Form.Item>
      );
    },
  },
];

export const OrderDetailColumns = (props, onChange) => [
  NoColumn,
  {
    title: "Бараа",
    dataIndex: "productid",
    key: "productid",
    width: 200,
    align: "center",
    render: (value, row, i) => (
      <Form.Item
        name={`dfieldproductid${i}`}
        initialValue={value}
        rules={[{ message: `Бараа сонгоно уу.`, required: true }]}
      >
        <Select
          className="sm:w-48 xl:w-full"
          showSearch
          defaultActiveFirstOption
          align="left"
          optionFilterProp="children"
          onChange={(e) => onChange({ value: e, i: i, name: "productid" })}
        >
          {renderOptions(props.resproductlist, "name", "id", true)}
        </Select>
      </Form.Item>
    ),
  },
  {
    title: "Тоо хэмжээ",
    dataIndex: "qty",
    key: "qty",
    align: "center",
    width: 130,
    render: (value, row, i) => (
      <Form.Item
        initialValue={value}
        name={`dfieldqty${i}`}
        rules={[
          { message: `Тоо хэмжээ.`, required: true },
          () => ({
            validator(_, value) {
              let regex = new RegExp(priceDecimal);
              if (!regex.test(value))
                return Promise.reject(new Error("2 оронгийн нарийвчлалтай."));
              return Promise.resolve();
            },
          }),
        ]}
      >
        <InputNumber
          className="sm:w-20 xl:w-full"
          min={0}
          max={99999.99}
          {...PRICE_PARSERS}
          onChange={(e) => onChange({ value: e, i: i, name: "qty" })}
        />
      </Form.Item>
    ),
  },
  {
    title: "Хэмжээ",
    dataIndex: "text",
    key: "text",
    align: "center",
    width: 180,
    render: (value, row, i) => (
      <Form.Item
        initialValue={value}
        name={`dfieldtext${i}`}
        rules={[{ message: `Хэмжээ оруулна уу.`, required: true }]}
      >
        <Input className="sm:w-24 xl:w-full" />
      </Form.Item>
    ),
  },
];

export const MoveDetailColumns = (props, onChange) => [
  NoColumn,
  {
    title: "Бараа",
    dataIndex: "productid",
    key: "productid",
    width: 200,
    align: "center",
    render: (value, row, i) => (
      <Form.Item
        name={`dfieldproductid${i}`}
        initialValue={value}
        rules={[{ message: `Бараа сонгоно уу.`, required: true }]}
      >
        <Select
          className="sm:w-48 xl:w-full"
          showSearch
          defaultActiveFirstOption
          align="left"
          optionFilterProp="children"
          onChange={(e) => onChange({ value: e, i: i, name: "productdrop" })}
        >
          {renderOptions(props.resproductdropdown, "name", "id", true)}
        </Select>
      </Form.Item>
    ),
  },
  {
    title: "Илгээх тоо",
    dataIndex: "qty",
    key: "qty",
    align: "center",
    width: 180,
    render: (value, row, i) => (
      <Form.Item initialValue={value} name={`dfieldqty${i}`}>
        <InputNumber
          className="sm:w-20 xl:w-full"
          min={0}
          max={99999.99}
          {...PRICE_PARSERS}
          onChange={(e) => onChange({ value: e, i: i, name: "qty" })}
        />
      </Form.Item>
    ),
  },
  {
    title: "Зарах үнэ",
    dataIndex: "price",
    key: "price",
    align: "center",
    width: 200,
    render: (value, row, i) => {
      return (
        <Form.Item initialValue={value} name={`dfieldprice${i}`}>
          <InputNumber
            className="sm:w-28 xl:w-full"
            disabled
            {...PRICE_PARSERS}
          />
        </Form.Item>
      );
    },
  },
  {
    title: "Нийт үнэ",
    dataIndex: "amount",
    key: "amount",
    align: "center",
    width: 200,
    render: (value, row, i) => {
      return (
        <Form.Item initialValue={value} name={`dfieldamount${i}`}>
          <InputNumber
            className="sm:w-28 xl:w-full"
            disabled
            {...PRICE_PARSERS}
          />
        </Form.Item>
      );
    },
  },
];

export const CountDetailColumns = [
  NoColumn,
  {
    title: "Бараа",
    dataIndex: "name",
    key: "name",
    width: 200,
  },
  {
    title: "Хэмжээ",
    dataIndex: "size",
    key: "size",
    width: 100,
  },
];

/* Кассчны тооцоо жагсаалтын хүснэгтийн баганууд */
export const CashierReportColumns = [
  NoColumn,
  {
    title: "Огноо",
    dataIndex: "insymd",
    key: "insymd",
    width: 130,
    align: "center",
    render: (value) => <Formatter value={value} format="date" />,
  },
  {
    title: "Дэлгүүрийн нэр",
    dataIndex: "storename",
    key: "storename",
  },
  {
    title: "Касс",
    dataIndex: "insbyname",
    key: "insbyname",
  },
  {
    title: "Бэлэн",
    dataIndex: "usercash",
    key: "usercash",
    isSum: true,
    align: "right",
    render: (value) => <Formatter value={value} format="price" />,
  },
  {
    title: "Бэлэн бус",
    dataIndex: "usernoncash",
    key: "usernoncash",
    isSum: true,
    align: "right",
    render: (value) => <Formatter value={value} format="price" />,
  },
  {
    title: "Мобайл",
    dataIndex: "usermobile",
    key: "usermobile",
    isSum: true,
    align: "right",
    render: (value) => <Formatter value={value} format="price" />,
  },
    {
    title: "Зээл",
    dataIndex: "loan",
    key: "loan",
    isSum: true,
    align: "right",
    render: (value) => <Formatter value={value} format="price" />,
  },
  {
    title: "Зардал",
    dataIndex: "cost",
    key: "cost",
    isSum: true,
    align: "right",
    render: (value) => <Formatter value={value} format="price" />,
  },
  {
    title: "Зардалын тайлбар",
    dataIndex: "text",
    key: "text",
    isSum: true,
    align: "right",
  },
  {
    title: "Нийт",
    dataIndex: "amount",
    key: "amount",
    isSum: true,
    align: "right",
    render: (value) => <Formatter value={value} format="price" />,
  },
  {
    title: "Кассын зөрүү",
    dataIndex: "diff",
    key: "diff",
    width: 150,
    isSum: true,
    align: "right",
  },
];

export const OrderModalColumns = [
  NoColumn,
  {
    title: "Барааны нэр",
    dataIndex: "productname",
    width: 120,
    key: "productname",
  },
  {
    title: "Ангилалын нэр",
    dataIndex: "catname",
    key: "catname",
    width: 150,
  },
  {
    title: "Зарах үнэ",
    dataIndex: "price",
    key: "price",
    width: 150,
  },
  {
    title: "Тоо ширхэг",
    dataIndex: "qty",
    key: "qty",
    width: 150,
  },
  {
    title: "Хэмжээ",
    dataIndex: "size",
    key: "size",
    width: 150,
  },
  {
    title: "Захиалгын огноо",
    dataIndex: "orderymd",
    key: "orderymd",
    width: 150,
    render: (value) => <Formatter value={value} format="date" />,
  },
];

export const InvLogModalColumns = [
  NoColumn,
  {
    title: "Барааны нэр",
    dataIndex: "productname",
    width: 120,
    key: "productname",
  },
  {
    title: "Өөрчилсөн тоо ширхэг",
    dataIndex: "qty",
    key: "qty",
    width: 150,
  },
  {
    title: "Тайлбар",
    dataIndex: "note",
    key: "note",
    width: 100,
  },
  {
    title: "Өөрчлөлт орсон огноо",
    dataIndex: "logymd",
    key: "logymd",
    width: 150,
    render: (value) => <Formatter value={value} format="date" />,
  },
  InsNameColumn,
];

export const CountLogModalColumns = [
  NoColumn,
  {
    title: "Барааны нэр",
    dataIndex: "productname",
    width: 120,
    key: "productname",
  },
  {
    title: "Тоолсон тоо ширхэг",
    dataIndex: "qty",
    key: "qty",
    width: 150,
    isSum: true,
    render: (value) => <Formatter value={value} format="price" />,
  },
  {
    title: "Барааны үнэ",
    dataIndex: "saleprice",
    key: "saleprice",
    width: 150,
    isSum: true,
    render: (value) => <Formatter value={value} format="price" />,
  },
  {
    title: "Нийт дүн",
    dataIndex: "ttlamt",
    key: "ttlamt",
    width: 100,
    isSum: true,
    render: (value) => <Formatter value={value} format="price" />,
  },
  {
    title: "Өөрчлөлт орсон огноо",
    dataIndex: "updymd",
    key: "updymd",
    width: 150,
    render: (value) => <Formatter value={value} format="date" />,
  },
];

export const BuyingLogModalColumns = [
  NoColumn,
  {
    title: "Барааны нэр",
    dataIndex: "productname",
    width: 180,
    key: "productname",
  },
  {
    title: "Зарах үнэ",
    dataIndex: "price",
    key: "price",
    width: 100,
    render: (value) => <Formatter value={value} format="price" />,
  },
  {
    title: "Тоо ширхэг",
    dataIndex: "qty",
    key: "qty",
    width: 120,
  },
  {
    title: "Нийт дүн",
    dataIndex: "amount",
    key: "amount",
    width: 150,
    isSum: true,
    align: "center",
    render: (value) => <Formatter value={value} format="price" />,
  },
  {
    title: "Татан авсан огноо",
    dataIndex: "logymd",
    key: "logymd",
    width: 150,
    render: (value) => <Formatter value={value} format="date" />,
  },
];

export const MoveLogModalColumns = [
  NoColumn,
  {
    title: "Барааны нэр",
    dataIndex: "productname",
    width: 180,
    key: "productname",
  },
  {
    title: "Зарах үнэ",
    dataIndex: "price",
    key: "price",
    width: 100,
    render: (value) => <Formatter value={value} format="price" />,
  },
  {
    title: "Тоо ширхэг",
    dataIndex: "outqty",
    key: "outqty",
    width: 120,
  },
  {
    title: "Нийт дүн",
    dataIndex: "amount",
    key: "amount",
    width: 150,
    isSum: true,
    align: "center",
    render: (value) => <Formatter value={value} format="price" />,
  },
  {
    title: "Хөдөлгөөн хийсэн огноо",
    dataIndex: "logymd",
    key: "logymd",
    width: 150,
    render: (value) => <Formatter value={value} format="date" />,
  },
];

/* Бэлэн бусын төлбөрийн задаргаа баганууд */
export const NonCashColumns = [
  NoColumn,
  {
    title: "Төрөл",
    dataIndex: "type",
    key: "type",
    width: 100,
    render: (value) => <Formatter value={value} format="paymentType" />,
  },
  {
    title: "Төлбөр",
    dataIndex: "amount",
    key: "amount",
    width: 100,
    isSum: true,
    render: (value) => <Formatter value={value} format="price" />,
  },
];

/* Касс хаалтын дата */
export const ClosePaymentData = [
  {
    amount: 20000,
    qty: 0,
    totalamt: 0,
  },
  {
    amount: 10000,
    qty: 0,
    totalamt: 0,
  },
  {
    amount: 5000,
    qty: 0,
    totalamt: 0,
  },
  {
    amount: 1000,
    qty: 0,
    totalamt: 0,
  },
  {
    amount: 500,
    qty: 0,
    totalamt: 0,
  },
  {
    amount: 100,
    qty: 0,
    totalamt: 0,
  },
  {
    amount: 50,
    qty: 0,
    totalamt: 0,
  },
  {
    amount: 20,
    qty: 0,
    totalamt: 0,
  },
  {
    amount: 10,
    qty: 0,
    totalamt: 0,
  },
];
